import { Parser } from "json2csv";
import { toast } from "react-toastify";

/**
 * Exports current page data to CSV
 * @param {Array} members - Array of member data from current page
 */
export const handleExportCSV = (members) => {
  if (members.length === 0) {
    toast.error("No data available to export");
    return;
  }
  const fields = [
    "id",
    "f_name",
    "l_name",
    "location",
    "average_gym_hours",
    "total_gym_hours",
    "access_status",
    "subscription_status",
  ];
  const opts = { fields };
  const parser = new Parser(opts);
  const csv = parser.parse(members);
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", "members.csv");
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
  toast.success("CSV file exported successfully!");
};

/**
 * Fetches all users from API and exports to CSV
 * @param {Object} axiosInstance - Configured axios instance with authentication
 * @param {string} locationId - Optional location ID to filter by
 */
export const handleExportCSVWithFetch = async (axiosInstance, locationId = "") => {
  try {
    const params = new URLSearchParams();
    if (locationId) {
      params.append('location_id', locationId);
    }
    const apiUrl = params.toString() ? `/get-all-users?${params.toString()}` : "/get-all-users";
    const response = await axiosInstance.get(apiUrl);
    const memberData = response.data.message;

    if (memberData.length === 0) {
      toast.error("No data available to export");
      return;
    }

    const fields = [
      "id",
      "f_name",
      "l_name",
      "location",
      "average_gym_hours",
      "total_gym_hours",
      "access_status",
      "subscription_status",
    ];
    const opts = { fields };
    const parser = new Parser(opts);
    const csv = parser.parse(memberData);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "members.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
    toast.success("All users CSV file exported successfully!");
  } catch (error) {
    console.error("Error fetching users or exporting CSV:", error);
    toast.error("An error occurred while exporting the data.");
  }
};
